import axios from "axios";

export const SECTION_URL = "/Section";
export const SECTION_RENEWAL_URL = "/SectionRenewal";

/** Mevcut Okulun Belli Bir Dönemdeki Belli Bir Şubesinin Belli Bir Öğrenci Listesini Elde Eder */
export function getStudents(queryParams) {
  return axios.post(`${SECTION_RENEWAL_URL}/GetStudents`, queryParams);
}

/** Mevcut Okulun Aktif Şube Listesini Elde Eder */
export function getSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Belli Bir Öğrenci Listesinin Yeni Dönemdeki Şubelerini Kaydeder */
export function saveSections(term, datas) {
  return axios.post(SECTION_RENEWAL_URL, { term, datas });
}